export default __webpack_public_path__ + "static/media/caret-down.bfd98d54.svg";